import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { deprecate } from '../utils/deprecate';
const TextPropTypes = {
    weight: PropTypes.oneOf(['normal', 'lighter']),
    align: PropTypes.oneOf(['left', 'center', 'right', 'justify']),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string,
    ]),
};
const BaseText = styled.p `
  text-rendering: optimizeLegibility;

  ${props => {
    if (props.align === 'left') {
        return css `
        text-align: left;
      `;
    }
    if (props.align === 'center') {
        return css `
        text-align: center;
      `;
    }
    if (props.align === 'right') {
        return css `
        text-align: right;
      `;
    }
    if (props.align === 'justify') {
        return css `
        text-align: justify;
      `;
    }
}}
`;
/**
 * @deprecated Please use <Typography /> instead
 * See: TOC-3542 unify typography
 * */
const StyledText = styled(BaseText) `
  line-height: ${props => props.theme.LineHeight};
  font-size: 1rem;
  font-weight: ${props => props.weight};
  margin: 0.75rem 0;
`;
/**
 * @deprecated Please use <Typography /> instead
 * See: TOC-3542 unify typography
 * */
const LeadText = styled(BaseText) `
  line-height: ${props => props.theme.LineHeight};
  font-family: ${props => props.theme.fonts.serif};
  font-size: 1.25rem;
  font-weight: ${props => props.weight};
  margin: 0.75rem 0;
`;
const IntroText = styled(BaseText) `
  line-height: ${props => props.theme.LineHeight};
  font-family: ${props => props.theme.fonts.serif};
  font-size: 1.75rem;
  font-weight: ${props => props.weight};
  margin: 0.75rem 0;
`;
/**
 * @deprecated Please use `<Paragraph />` instead
 * See: TOC-3542 unify typography
 */
export const Text = deprecate(props => {
    return React.createElement(StyledText, Object.assign({}, props), props && props.children);
}, '<Text /> is deprecated. Please use <Paragraph /> instead');
Text.propTypes = TextPropTypes;
Text.defaultProps = {
    children: null,
    weight: 'normal',
    align: 'left',
};
/**
 * @deprecated Please use `<Paragraph />` instead
 * See: TOC-3542 unify typography
 */
export const Lead = deprecate(props => {
    return React.createElement(LeadText, Object.assign({}, props), props && props.children);
}, '<Lead /> is deprecated. Please use <Paragraph /> instead');
Lead.propTypes = TextPropTypes;
Lead.defaultProps = {
    children: null,
    weight: 'lighter',
    align: 'left',
};
/**
 * @deprecated Please use `<Paragraph />` instead
 * See: TOC-3542 unify typography
 */
export const Intro = deprecate(props => {
    return React.createElement(IntroText, Object.assign({}, props), props && props.children);
}, '<Intro /> is deprecated. Please use <Paragraph /> instead');
Intro.propTypes = TextPropTypes;
Intro.defaultProps = {
    children: null,
    weight: 'lighter',
    align: 'left',
};
